/** Display names for API survey_type values (filters + cards). */
export const NPS_SURVEY_LABELS = {
  oxr_ops: 'OXR Ops',
  oxr_purchase: 'OXR Purchase',
  cap_ops: 'CAP Ops',
};

export const NPS_SURVEY_TYPE_OPTIONS = Object.entries(NPS_SURVEY_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export function getNpsSurveyLabel(surveyType) {
  if (!surveyType) return 'Survey';
  return NPS_SURVEY_LABELS[surveyType] || surveyType;
}
